<ng-container *transloco="let t">
  <div class="w-[min(80vw,70rem)]">
    <div class="ag-theme-quartz">
      <ag-grid-angular style="height: 40rem" [rowData]="gridData" [gridOptions]="gridOptions"></ag-grid-angular>
    </div>
  </div>
</ng-container>
